import { Grid } from "@mui/material";
import moment from "moment";
import * as React from "react";
import { DATE_FORMAT } from "../UsageSummary/UsageSummary";
import {
    GetFullBillingDetails,
    GetFullBillingDetailsVariables,
    GetFullBillingDetails_organization,
} from "./__generated__/GetFullBillingDetails";
import CardHESPTitle from "../CardHESP/CardHESPTitle";
import { useQuery } from "react-apollo";
import CentralLoader from "../Loading/CentralLoader";
import { GET_FULL_BILLING_DETAILS } from "./BillingDetailsCardContent";

interface Props {
    organization: GetFullBillingDetails_organization;
}

function CurrentBillingCommitment({ organization }: Props) {
    const { contracts, organizationId } = organization;
    const contract =
        contracts.filter((contract) => moment(contract.start) < moment() && moment(contract.end) > moment())[0] ??
        contracts[0];

    const { start: contractStart, end: contractEnd } = contract;

    const { data, loading } = useQuery<GetFullBillingDetails, GetFullBillingDetailsVariables>(
        GET_FULL_BILLING_DETAILS,
        {
            variables: {
                organizationId,
            },
        },
    );

    if (!data || loading) {
        return <CentralLoader />;
    }

    if (!data.organization.currentContract) {
        return <div>No current contract running</div>;
    }

    return (
        <Grid container>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <CardHESPTitle title="Contract Details" />
                            </Grid>
                            <Grid item xs={12}>
                                From <strong>{moment(contractStart).format(DATE_FORMAT)}</strong> until
                                <strong> {moment(contractEnd).format(DATE_FORMAT)}</strong>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CurrentBillingCommitment;
